// extracted by mini-css-extract-plugin
export var strike = "styles-module--strike--3961x";
export var authors = "styles-module--authors--dkGMq";
export var images = "styles-module--images--OXyLS";
export var image = "styles-module--image--ZJrzv";
export var names = "styles-module--names--4WPgy";
export var name = "styles-module--name--ELM1w";